import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.initializeNotifications()
    }

    initializeNotifications() {
        // Auto-hide success notifications after 5 seconds
        const notifications = document.querySelectorAll('.tangram-notification.notice, .tangram-notification.success')
        notifications.forEach(notification => {
            setTimeout(() => {
                this.removeNotification(notification)
            }, 5000)
        })

        // Add click handlers to all close buttons
        const closeButtons = document.querySelectorAll('.tangram-notification-close')
        closeButtons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const notification = e.target.closest('.tangram-notification')
                this.removeNotification(notification)
            })
        })
    }

    removeNotification(notification) {
        if (!notification) return

        notification.classList.add('removing')
        setTimeout(() => {
            notification.remove()

            // Remove container if no more notifications
            const container = document.querySelector('.tangram-notification-container')
            if (container && container.children.length === 0) {
                container.remove()
            }
        }, 300)
    }

    // Method to programmatically add notifications (useful for AJAX responses)
    static addNotification(type, message, autoHide = true) {
        let container = document.querySelector('.tangram-notification-container')

        if (!container) {
            container = document.createElement('div')
            container.className = 'tangram-notification-container'
            container.id = 'tangram-flash-notifications'
            document.body.appendChild(container)
        }

        const notificationClass = type === 'alert' || type === 'error' ? 'error' : 'notice'
        const headerText = notificationClass === 'error' ? 'Notice' : 'Success!'

        const notification = document.createElement('div')
        notification.className = `tangram-notification ${notificationClass}`
        notification.setAttribute('data-notification-type', type)

        notification.innerHTML = `
      <div class="tangram-notification-header">
        <strong>${headerText}</strong>
        <button type="button" class="tangram-notification-close" aria-label="Close">&times;</button>
      </div>
      <div class="tangram-notification-body">
        ${message}
      </div>
    `

        container.appendChild(notification)

        // Add close handler
        const closeBtn = notification.querySelector('.tangram-notification-close')
        closeBtn.addEventListener('click', () => {
            notification.classList.add('removing')
            setTimeout(() => notification.remove(), 300)
        })

        // Auto-hide if requested
        if (autoHide && notificationClass === 'notice') {
            setTimeout(() => {
                notification.classList.add('removing')
                setTimeout(() => notification.remove(), 300)
            }, 5000)
        }
    }
}

// Make the addNotification method globally available
window.TangramNotifications = {
    add: (type, message, autoHide = true) => {
        import('./flash_notifications_controller').then(module => {
            module.default.addNotification(type, message, autoHide)
        })
    }
} 